import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Route, Redirect, Switch } from 'react-router-dom'
import './common/css/reset.css'
import './common/css/bootstrap/bootstrap-grid.scss'
import './common/css/sos-icons.scss'
import './common/css/global.scss'
import './common/css/animate.css'
import { parseUrlQuery, hydrateSublinkFunctions } from 'utilities'
import { Content, SidebarNav, Footer } from 'components/Shell/Shell'
import Home from 'components/Home/Home'
// import Search from 'components/Search/Search'
import PublicSearchWrapper from './components/Search/PublicSearchWrapper.js'
import PrintResults from 'components/PrintResults/PrintResults'
// import FormManager from 'components/FormManager/FormManager'
import FormManagerWrapper from './components/FormManager/FormManagerWrapper.js'
// import Forms from 'components/Forms/Forms'
import FormsWrapper from './components/Forms/FormsWrapper.js'
// import Designer2 from 'components/Designer2/Designer2'
import DeferredDesigner from 'components/Designer2/DeferredDesigner'
import {
  ConnectedWizard,
  DraftEditor,
  CorrectionEditor,
  ReadOnlyWizard,
  AmendmentEditor,
  MiscellaneousAmendmentEditor,
  RecordEditWizard,
  SignaturesWizard,
  ProcessingWizard,
  ProcessingWizardDraft,
  StaffFilingCorrectionWizard,
} from 'components/Wizard2/Wizard'
import MyRecordsWrapper from 'components/MyRecords/MyRecordsWrapper'
import WorkviewManager2 from 'components/WVManager/WorkviewManager'
import RecordDetailsPage from 'components/RecordDetailsPage/RecordDetailsPage'
import MyWorkQueueWrapper from 'components/MyWorkQueue/MyWorkQueueWrapper'
import ReceiptPage from 'components/Checkout/ReceiptPage'
import PaymentError from 'components/Checkout/Error'
import LoginRedirector from 'components/LoginRedirector/LoginRedirector'
// import Dashboard from './components/Dashboard/Dashboard'
import { AdminLoginPage } from 'components/Shell/Login/Login'
import ChangePassword from 'components/Shell/Login/ChangePassword'
import { getAuthState, registerAuthPoll, skipAuthCheck } from './Auth/AuthActions'
import { getCachedSettings, initializeApp } from './actions'
import Migrate from 'components/Migrate/Migrate'
import HomeIcon from '@tecuity/sos-icons/react/home'
// import GaugeIcon from '@tecuity/sos-icons/react/gauge'
// import SearchDocsIcon from '@tecuity/sos-icons/react/search-docs'
import DollarSignDouble from '@tecuity/sos-icons/react/dollar-sign-double'
// import RSSIcon from '@tecuity/sos-icons/react/rss'
import DatabaseIcon from '@tecuity/sos-icons/react/database'
import SearchIcon from '@tecuity/sos-icons/react/search-thin'
import DocumentCloneIcon from '@tecuity/sos-icons/react/document-clone'
import BulletListIcon from '@tecuity/sos-icons/react/bullet-list'
import FileBoxIcon from '@tecuity/sos-icons/react/file-box'
import FileBoxTimeIcon from '@tecuity/sos-icons/react/file-box-time'
import GearsIcon from '@tecuity/sos-icons/react/gears'
import HelpIcon from '@tecuity/sos-icons/react/question-mark'
// import HistoryIcon from '@tecuity/sos-icons/react/history'
// import ChartIcon from '@tecuity/sos-icons/react/chart'
import PrintQueueIcon from '@tecuity/sos-icons/react/print-queue'
import { Helmet } from 'react-helmet'
import { LoginRedirectSwitch } from 'components/LoginRedirector/LoginRedirector'
import DeferredHealthCareDirective from 'components/HealthCareDirective/DeferredHealthCareDirective'
import NotFound from 'components/NotFound/NotFound'
import VerifyCertificate from 'components/Certificates/VerifyCertificate'
import UinGeneration from 'components/UinGeneration/UinGeneration'
import Toast from 'components/Toast/Toast'
import PaymentCallback from 'components/Checkout/PaymentCallback'
import PinsPage from 'components/MyRecords/PinsPage'
import RequestAccess from 'components/MyRecords/RequestAccess'
import DataRequests from 'components/DataRequests/DataRequests'
import FarmBill from './components/FarmBill/FarmBill'
import ApostilleVerification from './components/ApostilleVerification/ApostilleVerification'
import SignaturesManage from 'components/Signatures/ManageSignatures'
import VersionPage from 'components/Version/Version'
import UnsupportedBrowser from 'components/UnsupportedBrowser/UnsupportedBrowser'
import Announcer from 'components/Announcer/Announcer'
import Correspondence from './components/WVMCorrespondence/Correspondence'
import ImageViewer from './components/ImageViewer/DeferredImageViewer'
import ReportViewer from './components/ReportViewer/ReportViewer' //DeferredReportViewer
// import Reports from './components/Reports/Reports.js'
import PrintQueue from './components/PrintQueue/PrintQueue'
import Settings from './components/Settings/Settings'
import Accounting from './components/Accounting/Accounting'
import RedactionTool from './components/RedactionTool/RedactionTool'
// import Dashboards from './components/Dashboards/Dashboards'
import { Spinner } from './components/Loaders/Loaders'
import { ImageViewerController } from './components/ImageViewer/ImageViewer'
import ReportViewerController from './components/ReportViewer/ReportViewerController'
import PaymentConfirmation from './components/PaymentConfirmation/PaymentConfirmation'
import { BASE_URL } from './requests'
import OidcCallback from './components/LoginRedirector/OidcCallBack.js'
import ImageCropTool from './components/ImageCropTool/ImageCropTool.js'
import SessionTimeout from './components/SessionTimeout'
import NewList from './components/Lists/NewList.js'

let OktaCallback //, OktaRedirector
////////////////////////
////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////
//////////

let MiLoginCallback //, MiLoginRedirector
///////////////////////////
/////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////
//////////

const CleanUpPublicSetting = (publicSettings) => {
  return {
    ...publicSettings,
    Parameters: publicSettings.Parameters.map((param) =>
      param
        ? {
            ...param,
            defaultValue: param.defaultValue === '[]' ? [] : param.defaultValue,
            // eslint-disable-next-line
            getProps: param.getProps ? new Function('values', param.getProps) : param.getProps,
          }
        : param,
    ),
  }
}

let xhr = new XMLHttpRequest()
try {
  xhr.open(
    'GET',
    BASE_URL + '/api/SourceTypeConfiguration/GetAllActiveSourceTypeConfigurations',
    false,
  )
  xhr.send()
} catch (error) {
  console.error(error)
}

export const SUBROUTES = JSON.parse(xhr.status === 200 ? xhr.responseText : '[]').map(
  (settings) => {
    return settings.PublicSearchSettings
      ? { ...settings, PublicSearchSettings: CleanUpPublicSetting(settings.PublicSearchSettings) }
      : settings
  },
)

export const DISABLE_AUTH_CHECK = process.env.NODE_ENV == 'development' && false
export const ADDITIONAL_ROUTES = process.env.ADDITIONAL_ROUTES || {}

const constructSubroutes = (path, routes = SUBROUTES) => {
  const returnVal = routes
    .filter((route) => {
      if (route.allowedRoutes || route.AllowedRoutes) {
        return (route.allowedRoutes || route.AllowedRoutes).includes(path)
      }
      switch (path) {
        case '/records/':
          return (
            route.DisplayInMyRecord ||
            (route.IsMiscRecordsType &&
              route.MiscRecordsModules.filter((m) => m.DisplayInMyRecords).length > 0)
          )
        case '/queue/':
          return (
            route.DisplayInMyWorkQueue ||
            (route.IsMiscRecordsType &&
              route.MiscRecordsModules.filter((m) => m.DisplayInMyWorkQueue).length > 0)
          )
        case '/forms/':
          return (
            route.DisplayInForms ||
            (route.IsMiscRecordsType &&
              route.MiscRecordsModules.filter((m) => m.DisplayInForms).length > 0)
          )
        case '/FormsManager/':
          return (
            route.DisplayInFormsManager ||
            (route.IsMiscRecordsType &&
              route.MiscRecordsModules.filter((m) => m.DisplayInFormsManager).length > 0)
          )
        case '/settings/':
          return route.DisplayInSettings
        default:
          return !route.disabled
      }
    })
    .map((route) =>
      hydrateSublinkFunctions({
        ...route,
        path: path + route.parameter,
      }),
    )
  return returnVal
}

export const SUBROUTES_OBJ = SUBROUTES.reduce(
  (obj, route) => ({ ...obj, [route.parameter]: route }),
  {},
)

export const routes = [
  {
    label: 'Home',
    title: process.env.CUSTOM_HOME_TAB_TITLE || 'Online Business Services',
    includeInSidebar: true,
    icon: <HomeIcon />,
    component: Home,
    exact: true,
    link: '/',
    path: '/',
    subLinks: [],
    linkAvailableOffline: true,
  },
  {
    label: 'Search',
    title: 'Search',
    includeInSidebar: true,
    icon: <SearchIcon />,
    component: PublicSearchWrapper, // Search,
    link: '/search',
    path: '/search/:subParam?/:id?',
    subLinks: constructSubroutes(
      '/search/',
      SUBROUTES.filter(
        (x) =>
          (x.PublicSearchSettings && x.PublicSearchSettings.Enabled) ||
          (x.IsMiscRecordsType &&
            x.MiscRecordsModules.filter((m) => m.HasPublicSearch).length > 0) ||
          x.parameter === 'back-office',
      ),
    ),
    linkAvailableOffline: true,
  },
  {
    label: 'Record Details',
    title: 'Record Details',
    includeInSidebar: false,
    component: RecordDetailsPage,
    link: '/recordDetails',
    path: '/recordDetails/:subParam?/:id?',
    // subLinks: constructSubroutes('/search/'),
    linkAvailableOffline: true,
    authOnly: true,
    requiredRights: [
      'NotaryView',
      'ApostilleView',
      'TrademarkView',
      'UCCView',
      'BusinessView',
      'RegisteredAgentView',
      'CharityView',
      'DataRequestView',
    ],
  },
  {
    label: 'Print Results',
    title: 'Print Results',
    includeInSidebar: false,
    component: PrintResults,
    link: '/print-results',
    path: '/print-results',
    linkAvailableOffline: true,
    hideAppShell: true,
  },
  {
    label: 'Forms',
    title: 'Forms',
    includeInSidebar: true,
    icon: <DocumentCloneIcon />,
    component: FormsWrapper,
    path: '/forms/:category?',
    link: '/forms',
    exact: true,
    linkExact: false,
    // isActive: (match, location) => location.pathname.includes('/forms'),
    subLinks: constructSubroutes('/forms/'),
  },
  {
    label: 'Wizard Filing',
    title: 'File',
    includeInSidebar: false,
    icon: <DocumentCloneIcon />,
    component: ConnectedWizard,
    path: '/forms/new/:formDefinitionId',
    link: '/forms/0',
    subLinks: [],
    authOnly: false,
  },
  {
    label: 'Miscellaneous Wizard Filing',
    title: 'Miscellaneous File',
    includeInSidebar: false,
    icon: <DocumentCloneIcon />,
    component: ConnectedWizard,
    path: '/forms/miscellaneous/new/:formDefinitionId',
    link: '/forms/0',
    subLinks: [],
    authOnly: false,
  },
  {
    label: 'Wizard Processing',
    title: 'Process Wizard',
    includeInSidebar: false,
    component: ProcessingWizard,
    path: '/office/workview/process/:formDefinitionId/:amendmentNum?',
    link: '/office/workview/process/0',
    subLinks: [],
    authOnly: true,
    // showOfficeHeader: true,
    hideFooter: true,
    contentClassName: 'full-height-content blue-gray',
    requiredRights: ['ViewWorkview'],
  },
  {
    label: 'Miscellaneous Wizard Processing',
    title: 'Miscellaneous Process Wizard',
    includeInSidebar: false,
    component: ProcessingWizard,
    path: '/office/workview/miscellaneous/process/:formDefinitionId/:amendmentNum?',
    link: '/office/workview/miscellaneous/process/0',
    subLinks: [],
    authOnly: true,
    // showOfficeHeader: true,
    hideFooter: true,
    contentClassName: 'full-height-content blue-gray',
    requiredRights: ['ViewWorkview'],
  },
  {
    label: 'Staff Draft',
    title: 'Staff Draft',
    includeInSidebar: false,
    iconClass: '',
    component: ProcessingWizardDraft,
    path: '/office/workview/draft/process/:formDefinitionId/:amendmentNum?',
    link: '/office/workview/draft/process/0',
    subLinks: [],
    authOnly: true,
    hideFooter: true,
    contentClassName: 'full-height-content blue-gray',
    requiredRights: ['ViewWorkview'],
  },
  {
    label: 'Staff Filing Correction',
    title: 'Staff Filing Correction',
    includeInSidebar: false,
    iconClass: '',
    component: StaffFilingCorrectionWizard,
    path: '/office/workview/staffCorrection/:formDefinitionId/:amendmentNum',
    link: '/office/workview/staffCorrection/0/0',
    subLinks: [],
    authOnly: true,
    hideFooter: true,
    contentClassName: 'full-height-content blue-gray',
    requiredRights: ['ViewWorkview', 'StaffFilingCorrection'],
  },
  {
    label: 'Wizard Sign',
    title: 'Sign',
    includeInSidebar: false,
    icon: <DocumentCloneIcon />,
    component: SignaturesWizard,
    path: '/forms/sign/:token',
    link: '/forms/0',
    subLinks: [],
    authOnly: false,
  },
  {
    label: 'Farm Bill',
    title: 'Farm Bill',
    icon: <SearchIcon />,
    component: FarmBill,
    path: '/lists/farm-bill',
    link: '/lists/farm-bill',
    authOnly: true,
    exact: true,
    subLinks: constructSubroutes(
      '/search/',
      SUBROUTES.filter((x) => x.component === 'FarmBill'),
    ),
    linkAvailableOffline: true,
    includeInSidebar: false,
  },
  ...(ADDITIONAL_ROUTES.lists !== false
    ? [
        {
          label: 'Lists',
          title: 'Lists',
          includeInSidebar: false,
          component: NewList,
          icon: <BulletListIcon />,
          path: '/lists',
          link: '/lists/:category',
          subLinks: [],
          linkAvailableOffline: false,
        },
      ]
    : []),
  {
    label: 'Workview Manager',
    title: 'Workview Manager',
    includeInSidebar: true,
    component: WorkviewManager2,
    icon: <FileBoxIcon />,
    link: '/office/workview',
    path: '/office/workview/:workviewId?',
    authOnly: true,
    contentClassName: 'full-height-content',
    renderHistorySidebar: true,
    hideFooter: true,
    collapseSidebar: true,
    requiredRights: ['ViewWorkview'],
  },
  // {
  //   label: 'My Recent Filings',
  //   title: 'My Recent Filings',
  //   includeInSidebar: true,
  //   component: () => (<div>My Recent Filings placeholder</div>), // still need to add this to the app
  //   icon: <HistoryIcon/>,
  //   link: '/office/my-recent-filings',
  //   path: '/office/my-recent-filings', // needs to change, just placeholder for now
  //   authOnly: true, // not sure
  // },
  {
    label: 'Correct',
    title: 'Correct',
    includeInSidebar: false,
    component: Correspondence,
    //look at connected wizard example to wrap corresponse in wrapper
    path: '/office/correspondence/correct',
    link: '/office/correspondence/correct',
    subLinks: [],
    authOnly: true,
    // showOfficeHeader: true,
    contentClassName: 'full-height-content blue-gray',
    collapseSidebar: true,
    requiredRights: ['ViewWorkview'],
  },
  {
    label: 'Correct',
    title: 'Correct',
    includeInSidebar: false,
    component: Correspondence,
    //look at connected wizard example to wrap corresponse in wrapper
    path: '/office/correspondence/correct/:amendmentId',
    link: '/office/correspondence/correct/0',
    subLinks: [],
    authOnly: true,
    // showOfficeHeader: true,
    contentClassName: 'full-height-content blue-gray',
    collapseSidebar: true,
    requiredRights: ['ViewWorkview'],
  },
  {
    label: 'Reject',
    title: 'Reject',
    includeInSidebar: false,
    component: Correspondence,
    path: '/office/correspondence/reject',
    link: '/office/correspondence/reject',
    subLinks: [],
    authOnly: true,
    // showOfficeHeader: true,
    contentClassName: 'full-height-content blue-gray',
    collapseSidebar: true,
    requiredRights: ['ViewWorkview'],
  },
  {
    label: 'Reject',
    title: 'Reject',
    includeInSidebar: false,
    component: Correspondence,
    path: '/office/correspondence/reject/:amendmentId',
    link: '/office/correspondence/reject/0',
    subLinks: [],
    authOnly: true,
    // showOfficeHeader: true,
    contentClassName: 'full-height-content blue-gray',
    collapseSidebar: true,
    requiredRights: ['ViewWorkview'],
  },
  {
    label: 'Crop Trademark Specimen',
    title: 'Crop Trademark Specimen',
    includeInSidebar: false,
    component: ImageCropTool,
    path: '/office/imageCropTool',
    link: '/office/imageCropTool',
    subLinks: [],
    authOnly: true,
    contentClassName: 'full-height-content blue-gray image-crop-content',
    collapseSidebar: true,
    requiredRights: ['ViewWorkview'],
  },
  {
    label: 'My Work Queue',
    title: 'My Work Queue',
    includeInSidebar: true,
    component: MyWorkQueueWrapper,
    icon: <FileBoxTimeIcon />,
    link: '/queue',
    path: '/queue/:category?',
    subLinks: constructSubroutes('/queue/'),
    authOnly: true,
  },
  {
    label: 'My Records',
    title: 'My Records',
    includeInSidebar: true,
    icon: <FileBoxIcon />,
    link: '/records',
    path: '/records/:subParam?',
    component: MyRecordsWrapper,
    subLinks: constructSubroutes('/records/'),
    authOnly: true,
  },
  ...(SUBROUTES.find((x) => x.SourceTypeId == 869)
    ? [
        {
          label: process.env.DATA_REQUEST_SIDEBAR_LABEL || 'Data Requests',
          title: process.env.DATA_REQUEST_SIDEBAR_LABEL || 'Data Requests',
          includeInSidebar: true,
          icon: <DatabaseIcon />,
          component: DataRequests,
          path: '/data-requests',
          link: '/data-requests',
          authOnly: true,
          alwaysShowInSidebar: process.env.DATA_REQUEST_ALWAYS_SHOW_IN_SIDEBAR || false,
        },
      ]
    : []),
  {
    label: 'Forms Manager',
    title: 'Forms Manager',
    includeInSidebar: true,
    icon: <DocumentCloneIcon />,
    component: FormManagerWrapper,
    exact: true,
    linkExact: false,
    path: '/FormsManager/:category?',
    link: '/FormsManager',
    subLinks: constructSubroutes('/FormsManager/'),
    authOnly: true,
    requiredRights: ['ModifyForms'],
  },
  {
    label: 'Form Designer',
    title: 'Edit',
    includeInSidebar: false,
    icon: <DocumentCloneIcon />,
    component: DeferredDesigner,
    path: '/FormsManager/edit/:formDefinitionId',
    link: '/FormsManager/edit/0',
    subLinks: [],
    collapseSidebar: true,
    authOnly: true,
    requiredRights: ['ModifyForms'],
    hideFooter: process.env.HIDE_FOOTER_FORMS_MANAGER || false,
  },
  {
    label: 'PaymentConfirmation',
    component: PaymentConfirmation,
    includeInSidebar: false,
    path: '/paymentConfirmation/',
  },
  // {
  //   label: 'Reports',
  //   title: 'Reports',
  //   includeInSidebar: false,
  //   icon: <SearchDocsIcon />,
  //   component: Reports,
  //   link: '/reports/',
  //   path: '/reports/:category?',
  //   subLinks: constructSubroutes('/reports/'),
  //   collapseSidebar: true,
  //   authOnly: true,
  //   //allowedUserGroups: ['ADMIN', 'ADMIN_WEB'],
  //   //requiredRights
  // },
  // ...(ADDITIONAL_ROUTES.dashboard
  //   ? [
  //       {
  //         label: 'Dashboard',
  //         title: 'Dashboard',
  //         includeInSidebar: true,
  //         icon: <ChartIcon />,
  //         component: Dashboards,
  //         // exact: true,
  //         // linkExact: true,
  //         link: '/dashboard/dashboard',
  //         path: '/dashboard/:category?',
  //         subLinks: constructSubroutes('/dashboard/'),
  //         collapseSidebar: true,
  //         authOnly: true,
  //         // allowedUserGroups: ['ADMIN', 'ADMIN_WEB'],
  //       },
  //     ]
  //   : []),
  {
    label: 'Accounting',
    title: 'Accounting',
    includeInSidebar: true,
    icon: <DollarSignDouble />,
    component: Accounting,
    exact: true,
    linkExact: true,
    // link: "/search",
    // path: "/search/:subParam?/:id?",
    path: '/accounting/:category?/:id?',
    link: '/accounting',
    authOnly: true,
    requiredRights: [
      'ReceiptView',
      'ReceiptCreate',
      'ReceiptVoid',
      'ManageFrequentPayor',
      'ReceiptCloseBatch',
      'ReceiptReconcileBatch',
      'ReceiptReconcileOthersBatch',
      'ReceiptUnreconcile',
    ],
  },
  {
    label: 'Print Queue',
    title: 'Print Queue',
    includeInSidebar: true,
    icon: <PrintQueueIcon />,
    component: PrintQueue,
    exact: true,
    linkExact: false,
    path: '/printQueue/',
    link: '/printQueue',
    authOnly: true,
    requiredRights: ['PrintQueueViewEntries'],
    contentClassName: 'full-height-content',
    //renderHistorySidebar: true,
    hideFooter: true,
    collapseSidebar: true,
  },
  {
    label: 'Settings',
    title: 'Settings',
    includeInSidebar: true,
    icon: <GearsIcon />,
    component: Settings,
    exact: true,
    linkExact: false,
    path: '/settings/:category?/:setting?/',
    link: '/settings/',
    subLinks: constructSubroutes('/settings/'),
    authOnly: true,
    requiredRights: ['EditAppSettings'],
  },
  {
    label: 'Receipt',
    title: 'Payment Successful',
    includeInSidebar: false,
    iconClass: '',
    component: ReceiptPage,
    path: '/receipt',
    link: '/receipt',
    subLinks: [],
    // authOnly: true
  },
  {
    label: 'Signatures Manager',
    title: 'Signatures Manager',
    includeInSidebar: false,
    iconClass: '',
    component: SignaturesManage,
    path: '/signatures/:groupToken',
    link: '/signatures/:groupToken',
    subLinks: [],
  },
  {
    label: 'PaymentCallback',
    title: 'Processing Payment',
    includeInSidebar: false,
    iconClass: '',
    component: PaymentCallback,
    path: '/processpayment/:method',
    link: '/processpayment',
    subLinks: [],
    // authOnly: true
  },
  {
    label: 'Payment Error',
    title: 'Error Processing Payment',
    includeInSidebar: false,
    component: PaymentError,
    path: '/paymenterror/:method',
    link: '/paymenterror/:method',
    subLinks: [],
    authOnly: false,
  },
  {
    label: 'Draft',
    title: 'Draft',
    includeInSidebar: false,
    iconClass: '',
    component: DraftEditor,
    path: '/draft/:draftId',
    link: '/draft',
    subLinks: [],
    authOnly: true,
  },
  {
    label: 'Miscellaneous Correction',
    title: 'Miscellaneous Correction',
    includeInSidebar: false,
    iconClass: '',
    component: CorrectionEditor,
    path: '/correct/miscellaneous/:formDefinitionId/:amendmentNum',
    link: '/correct/miscellaneous',
    subLinks: [],
    authOnly: true,
  },
  {
    label: 'Correction',
    title: 'Correction',
    includeInSidebar: false,
    iconClass: '',
    component: CorrectionEditor,
    path: '/correct/:formDefinitionId/:amendmentNum',
    link: '/correct',
    subLinks: [],
    authOnly: true,
  },
  {
    label: 'Amend',
    title: 'Amend',
    includeInSidebar: false,
    iconClass: '',
    component: AmendmentEditor,
    path: '/amend/:formDefinitionId/:amendmentNum',
    link: '/amend',
    subLinks: [],
    authOnly: process.env.AMEND_ROUTE_PUBLIC ? false : true,
  },
  {
    label: 'Miscellaneous Amendment',
    title: 'Miscellaneous Amendment',
    includeInSidebar: false,
    iconClass: '',
    component: MiscellaneousAmendmentEditor,
    path: '/miscellaneous/amend/:formDefinitionId/:recordNum',
    link: '/miscellaneous/amend',
    subLinks: [],
    authOnly: false,
  },
  {
    label: 'EditRecord',
    title: 'EditRecord',
    includeInSidebar: false,
    iconClass: '',
    component: RecordEditWizard,
    path: '/editrecord/:formDefinitionId/:amendmentNum',
    link: '/editrecord',
    subLinks: [],
    authOnly: true,
  },
  {
    label: 'ChangePassword',
    includeInSidebar: false,
    iconClass: '',
    component: ChangePassword,
    path: '/passwordreset',
    link: '/passwordreset',
    subLinks: [],
    authOnly: false,
  },
  {
    label: 'SetPassword',
    includeInSidebar: false,
    iconClass: '',
    component: ChangePassword,
    path: '/setpassword',
    link: '/setpassword',
    subLinks: [],
    authOnly: false,
  },
  {
    label: 'LoginRedirector',
    title: 'Login',
    includeInSidebar: false,
    iconClass: '',
    component: LoginRedirector,
    path: '/auth/:returnPath?',
    link: '/auth',
    subLinks: [],
    authOnly: false,
  },
  {
    label: 'Session Timeout',
    title: 'Session Timeout',
    includeInSidebar: false,
    iconClass: '',
    component: SessionTimeout,
    link: '/session-timeout',
    path: '/session-timeout',
  },
  {
    label: 'OidcCallback',
    title: 'Login',
    includeInSidebar: false,
    iconClass: '',
    component: process.env.IS_OIDC ? OidcCallback : Home,
    path: '/call-back',
    link: '/call-back',
    subLinks: [],
    authOnly: false,
  },
  {
    label: 'AdminLogin',
    title: 'Admin Login',
    includeInSidebar: false,
    iconClass: '',
    component: AdminLoginPage,
    path: '/admin',
    link: '/admin',
    sublinks: [],
    authOnly: false,
  },
  // {
  //   label: "Reset Password",
  //   title: "Reset Password",
  //   includeInSidebar: false,
  //   iconClass: "",
  //   component: ResetPassword,
  //   path: '/passwordreset',
  //   link: '/passwordreset',
  //   sublinks: [],
  //   authOnly: false
  // },
  {
    label: 'ReadOnlyWizard',
    includeInSidebar: false,
    iconClass: '',
    component: ReadOnlyWizard,
    path: '/view/:formDefinitionId/:amendmentNum',
    link: '/view',
    subLinks: [],
    authOnly: true,
  },
  {
    label: 'MiscellaneousReadOnlyWizard',
    includeInSidebar: false,
    iconClass: '',
    component: ReadOnlyWizard,
    path: '/miscellaneous/view/:formDefinitionId/:amendmentNum',
    link: '/view',
    subLinks: [],
    authOnly: true,
  },
  {
    label: 'Miscellaneous Draft',
    title: 'Miscellaneous Draft',
    includeInSidebar: false,
    iconClass: '',
    component: DraftEditor,
    path: '/miscellaneous/draft/:draftId',
    link: '/miscellaneous/draft',
    subLinks: [],
    authOnly: false,
  },
  {
    label: 'Wizard Migration Tool',
    title: 'Migrate',
    includeInSidebar: false,
    iconClass: '',
    component: Migrate,
    path: '/migrate',
    link: '/migrate',
    sublinks: [],
    authOnly: true,
  },
  {
    label: 'Verify Certificates',
    title: 'Verify Certificates',
    includeInSidebar: false,
    iconClass: '',
    component: VerifyCertificate,
    path: '/verifycertificate',
    link: '/verifycertificate',
    sublinks: [],
    authOnly: false,
  },
  {
    label: 'Request Access',
    title: 'Request Access',
    includeInSidebar: false,
    iconClass: '',
    component: RequestAccess,
    path: '/requestaccess',
    link: '/requestaccess',
    sublinks: [],
    authOnly: true,
  },
  {
    label: 'UIN Generation',
    title: 'UIN Generation',
    includeInSidebar: false,
    iconClass: '',
    component: UinGeneration,
    path: '/UinGeneration',
    link: '/UinGeneration',
    sublinks: [],
    authOnly: false,
  },
  {
    label: 'Image Viewer',
    title: 'Image Viewer',
    includeInSidebar: false,
    iconClass: '',
    component: ImageViewer,
    path: '/image-viewer/:envelopeId/:imageViewerDln?',
    link: '/image-viewer',
    sublinks: [],
    authOnly: false,
    hideAppShell: true,
    hideSidebar: true,
    requiredRights: ['ViewImages'],
  },
  {
    label: 'Report Viewer',
    title: 'Report Viewer',
    includeInSidebar: false,
    iconClass: '',
    component: ReportViewer,
    path: '/report-viewer',
    link: '/report-viewer',
    sublinks: [],
    authOnly: false,
    hideAppShell: true,
    hideSidebar: true,
    requiredRights: ['ViewImages'],
  },
  {
    label: 'Image Redact',
    title: 'Image Redact',
    includeInSidebar: false,
    iconClass: '',
    component: RedactionTool,
    path: '/image-redaction/:imageNumber',
    link: '/image-redaction',
    sublinks: [],
    authOnly: false,
    hideAppShell: true,
    hideSidebar: true,
  },
  ...(process.env.HAS_MILOGIN
    ? [
        {
          label: 'MiLogin Callback',
          title: 'MiLogin Callback',
          includeInSidebar: false,
          iconClass: '',
          component: MiLoginCallback,
          path: '/milogin-callback',
          link: '/milogin-callback',
          sublinks: [],
          authOnly: false,
        },
      ]
    : []),
  ...(process.env.HAS_OKTA_LOGIN
    ? [
        {
          label: 'Okta Callback',
          title: 'Okta Callback',
          includeInSidebar: false,
          iconClass: '',
          component: OktaCallback,
          path: '/okta-callback',
          link: '/okta-callback',
          sublinks: [],
          authOnly: false,
        },
      ]
    : []),
  ...(ADDITIONAL_ROUTES.externalHelp !== undefined && ADDITIONAL_ROUTES.externalHelp !== false
    ? [
        {
          label: 'Help',
          title: 'Help',
          path: ADDITIONAL_ROUTES.externalHelp,
          link: ADDITIONAL_ROUTES.externalHelp,
          authOnly: false,
          includeInSidebar: true,
          linkAvailableOffline: true,
          external: true,
          icon: <HelpIcon />,
        },
      ]
    : []),
  ...(ADDITIONAL_ROUTES.genericPins
    ? [
        {
          label: 'Enter PIN',
          title: 'Enter PIN',
          includeInSidebar: false,
          iconClass: '',
          component: PinsPage,
          path: '/pins',
          link: 'pins',
          sublinks: '',
          authOnly: false,
          codeSplit: true,
        },
      ]
    : []),
  ...(process.env.NODE_ENV === 'development'
    ? [
        {
          label: 'Sandbox',
          title: 'Sandbox',
          includeInSidebar: true,
          icon: <GearsIcon />,
          component: Sandbox,
          path: '/sandbox',
          link: '/sandbox',
          codeSplit: true,
          collapseSidebar: true,
          linkAvailableOffline: true,
        },
      ]
    : []),
  ...(ADDITIONAL_ROUTES.healthCareDirective
    ? [
        {
          label: 'Health Care Directive',
          title: 'Health Care Directive',
          includeInSidebar: false,
          component: DeferredHealthCareDirective,
          path: '/hcdr',
          link: '/hcdr',
          codeSplit: true,
          collapseSidebar: false,
        },
      ]
    : []),
  ...(ADDITIONAL_ROUTES.apostille
    ? [
        {
          label: 'Apostille Verification',
          title: 'Apostille Verification',
          includeInSidebar: false,
          component: ApostilleVerification,
          path: '/apostille',
          link: '/apostille',
          codeSplit: true,
          collapseSidebar: false,
        },
      ]
    : []),
  {
    label: 'Version',
    title: 'Version',
    includeInSidebar: false,
    path: '/version',
    link: '/version',
    authOnly: false,
    component: VersionPage,
  },
]

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      appInitialized: false,
    }
  }
  componentDidMount = () => {
    const skipAuthCheck = (parseUrlQuery(this.props.location.search || '?') || {}).skipAuthCheck
    if (!skipAuthCheck) {
      this.props.getAuthState()
    } else {
      this.props.skipAuthCheck()
    }

    this.props.initializeApp(this.setInitialized)

    this.props.getCachedSettings()
  }
  setInitialized = () => {
    if (this.props.TruValidateIsEnabled) {
      window.io_global_object_name = 'IGLOO'
      window.IGLOO = window.IGLOO || {
        // "bbout_element_id" : "ioBlackBox",
        enable_flash: false,
        // "bb_callback" : function (bb, complete){
        //     var field = document.getElementById("ioBlackBox");
        //     field.value = bb;
        //     console.log(bb);
        //     console.log(complete);
        // },
        loader: {
          uri_hook: `/iojsrp`,
          version: 'general5',
          subkey: 'ZxLTDmZvthK-mqwBZc7TYtn9NTE5vVKiurdawZ9ZoEU',
        },
      }
      require('./components/TruValidate/loader.js')
    }
    this.setState({ appInitialized: true })
  }
  componentDidUpdate = (prevProps) => {
    const mobileLocationHasChanged =
      this.props.isMobile && this.props.location.pathname !== prevProps.location.pathname
    if (mobileLocationHasChanged) {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    }
  }
  componentDidCatch = (err) => {
    switch (err.name) {
      case 'AuthSdkError':
        this.setState({ showBrowserUpgradeMessage: true })
        break
      default:
    }
  }
  render() {
    const { location, loggedIn, siteOffline, isUnsupportedBrowser, appUserRights } = this.props

    return (
      <React.Fragment>
        {this.state.appInitialized ? (
          <div className={`App ${isUnsupportedBrowser ? 'unsupported-browser' : ''}`}>
            {process.env.CUSTOM_HEADER && (
              <div
                id="custom-header"
                dangerouslySetInnerHTML={{ __html: process.env.CUSTOM_HEADER }}
              ></div>
            )}
            <SidebarNav links={routes} location={location} />
            <Switch>
              {routes.map((route, i) => (
                <Route
                  path={route.path}
                  exact={route.exact}
                  render={(props) => {
                    let renderedComponent = (
                      <Content
                        currentPath={location.pathname}
                        links={routes}
                        currentRoute={route}
                        subLinks={route.subLinks}
                        authOnly={route.authOnly}
                        sidebarCollapsed={route.collapseSidebar}
                        hideAppShell={route.hideAppShell}
                        hideSidebar={route.hideSidebar}
                        hideFooter={route.hideFooter}
                        renderHistorySidebar={route.renderHistorySidebar}
                        showOfficeHeader={route.showOfficeHeader}
                        className={route.contentClassName}
                      >
                        <Helmet>
                          <title>{`${route.title || ''} | ${
                            process.env.CUSTOM_TAB_TITLE || process.env.STATE_NAME
                          } ${process.env.STATE_ORG_TITLE}`}</title>
                        </Helmet>
                        <route.component {...props} sublinks={route.subLinks} />
                      </Content>
                    )
                    if (route.authOnly) {
                      if (siteOffline) {
                        return <Redirect to="/" />
                      }
                      if (loggedIn) {
                        if (route.requiredRights && route.requiredRights.length > 0) {
                          if (route.requiredRights.find((right) => appUserRights.includes(right))) {
                            return renderedComponent
                          } else {
                            return <Redirect to="/" />
                          }
                        } else {
                          return renderedComponent
                        }
                      } else if (!loggedIn) {
                        return <LoginRedirectSwitch location={location} />
                      }
                    } else {
                      return renderedComponent
                    }
                  }}
                  key={i}
                />
              ))}
              <Route
                render={(props) => (
                  <Content
                    currentPath={location.pathname}
                    links={routes}
                    currentRoute={{}}
                    subLinks={[]}
                    authOnly={false}
                    sidebarCollapsed={false}
                  >
                    <Helmet>
                      <title>{`404 Not Found | ${process.env.STATE_NAME} ${process.env.STATE_ORG_TITLE}`}</title>
                    </Helmet>
                    <NotFound />
                  </Content>
                )}
              />
            </Switch>
            <Toast
              danger={!!this.props.toastError}
              success={!!this.props.toastSuccess}
              message={this.props.toastError || this.props.toastSuccess}
            />
            {process.env.CUSTOM_FOOTER ? (
              <Footer footerContent={process.env.CUSTOM_FOOTER}></Footer>
            ) : (
              <Footer copyright={`${process.env.STATE_ABBR} Secretary of State`} />
            )}
            {isUnsupportedBrowser && <UnsupportedBrowser />}
            <Announcer />
          </div>
        ) : (
            <Spinner className="app-page-loader" themeColor="dark-neutral" />
        )}
        <ImageViewerController />

        <ReportViewerController />
      </React.Fragment>
    )
  }
}

export default connect(
  (state) => ({
    loggedIn: state.auth.loggedIn,
    userGroup: state.auth.USER_GROUP,
    isMobile: state.app.isMobile,
    toastError: state.app.toastError,
    toastSuccess: state.app.toastSuccess,
    siteOffline: state.app.appSettings.WEBSITE_PORTAL_OFFLINE_YN === true,
    isUnsupportedBrowser: state.app.isUnsupportedBrowser,
    TruValidateIsEnabled: state.app.appSettings.TruValidateIsEnabled || false,
    appUserRights: state.auth.appUserRights || [],
  }),
  { getAuthState, initializeApp, registerAuthPoll, skipAuthCheck, getCachedSettings },
)(App)
